import { FC } from 'react';

import withSchema from 'ia-react-core/~/hocs/schema/withSchema';
import { DrawerState } from 'ia-react-core/~/interfaces/DrawerState';
import { ParametersExceptFirst } from 'ia-react-core/~/interfaces/ParametersExceptFirst';

import closeDrawerById from '../../../actions/drawer-fn/closeDrawerById';
import openDrawerById from '../../../actions/drawer-fn/openDrawerById';
import injectAnalyticsScope from '../../../hocs/analytics/injectAnalyticsScope';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import injectReducer from '../../../hocs/redux/injectReducer';
import compose from '../../../utils/components/_compose';

import Drawer, { DrawerComposedProps, DrawerProps } from './Drawer';
import drawerReducer from './Drawer.reducer';

type DrawerStatics = {
  Content: typeof Drawer.Content;
  Footer: typeof Drawer.Footer;
  defaultProps: typeof Drawer.defaultProps;
  appElement: typeof Drawer.appElement;
  setAppElement: typeof Drawer.setAppElement;
};

export * from './Drawer';

const ComposedDrawer = compose<FC<DrawerProps> & DrawerStatics>(
  withUniqueId('drawerId'),
  withSchema('drawer', { skip: ({ isOpened }) => typeof isOpened !== 'undefined' }),
  injectAnalyticsScope<DrawerComposedProps>({
    key: ({ name }) => name,
  }),
  injectReducer<DrawerComposedProps, DrawerState>({
    key: ({ name }) => name,
    idName: 'drawerId',
    namespace: 'Core/Drawer',
    skip: ({ isOpened }) => typeof isOpened !== 'undefined',
    identifiers: ({ drawerId, name }) => ({ drawerId, name }),
    reducer: drawerReducer,
    actions: ({ drawerId: currentDrawerId }) => ({
      openDrawer: (...args: ParametersExceptFirst<typeof openDrawerById>) => openDrawerById(currentDrawerId, ...args),
      closeDrawer: (...args: ParametersExceptFirst<typeof closeDrawerById>) => closeDrawerById(currentDrawerId, ...args),
    }),
    initialState: ({ drawerId, name, initialIsOpened }) => ({
      drawerId,
      name,
      isOpened: Boolean(initialIsOpened),
    }),
    useScope: true,
    createScope: false,
    cleanState: true,
  }),
)(Drawer);

ComposedDrawer.displayName = 'Drawer';

export default ComposedDrawer;
